import React, { useState } from "react";
import { Button, IconButton, Skeleton, MenuItem, Select, FormControl, Alert } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { HiInbox } from 'react-icons/hi2';
import "./TheStudentDashboard.css";
import { history } from "../../../../../../helper/history";
import { routes } from "../../../../../../helper/routes";
import Papers from './imageFiles/Papers.png';
import CustomGradeDropdown from "./CustomGradeDropdown ";
const PaperDetails = ({ availablePapers, enrolledPapers, completedPapers, student_dashboard_initial_loading }) => {

  const [tabIndex, setTabIndex] = useState(0);
  const [grade, setGrade] = useState("All");

  const handleChangeGrade = (event) => {
    setGrade(event.target.value);
  };

  const skeletonPapers = Array(5).fill({});

  const handleOnClickEnrol = () => {
    history.push(routes.find_papers)
  }

  return (
    <div className="paper-details-section">
      <div className="paper-tabs">
        <button
          className={`MuiTab-root ${tabIndex === 0 ? 'Mui-selected' : ''}`}
          onClick={() => setTabIndex(0)}
        >
          Available
        </button>
        <button
          className={`MuiTab-root ${tabIndex === 1 ? 'Mui-selected' : ''}`}
          onClick={() => setTabIndex(1)}
        >
          Enrolled
        </button>
        <button
          className={`MuiTab-root ${tabIndex === 2 ? 'Mui-selected' : ''}`}
          onClick={() => setTabIndex(2)}
        >
          Completed
        </button>
      </div>
      {student_dashboard_initial_loading ? (

        <div className="paper-list">
          {skeletonPapers.map((_, index) => (
            <div className="paper-row" key={`skeleton-${index}`}>
              <div className="paper-info">
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  className="paper-icon"
                  animation="pulse"
                />
                <div className="paper-text">
                  <Skeleton variant="text" width={250} height={24} />
                  <Skeleton variant="text" width={130} height={24} />
                  <Skeleton variant="text" width={100} height={20} />
                  <Skeleton variant="text" width={80} height={20} />
                </div>
              </div>
              <div className="paper-actions">
                <Skeleton variant="rounded" width={80} height={36} animation="pulse" />
                <Skeleton variant="circular" width={36} height={36} />
              </div>
            </div>
          ))}
        </div>

      ) : (
        <>
          {tabIndex === 0 && (
            <div className="paper-list">
              <Alert severity="info" variant="outlined" className="available-warning" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1, borderRadius: '8px', color: '#5f97d3', borderColor: '#709fd2', backgroundColor: '#f4f8fb' }}>
                Available exams for your <strong>grade</strong> and <strong>language</strong> are shown here
              </Alert>
              {availablePapers && availablePapers.length > 0 ? (
                availablePapers.map((paper, index) => (
                  <div className="paper-row" key={index}>
                    <div className="paper-info col-12 px-0">
                      <div className="paper-info col-md-5 px-0">
                        <img src={Papers} alt="icon" className="paper-icon" />
                        <p className="subject">{paper.assess_name}</p>
                      </div>
                      <div className="paper-text col-md-7 px-0">
                        <div className="col-md-4 px-0">
                          <p className="subject">{paper.subject_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">{paper.language_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">Grade {paper.grade_name || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state-box">
                  <HiInbox className="empty-state-icon" />
                  <p className="empty-state-text">No exams available at this time</p>
                  {/* <p className="empty-state-subtext">Check back later for new assessments</p> */}
                </div>
              )}
            </div>
          )}

          {tabIndex === 1 && (
            <div className="paper-list">
              {enrolledPapers && enrolledPapers.length > 0 ? (
                enrolledPapers.map((enrolled_paper, index) => (
                  <div className="paper-row" key={index}>
                    <div className="paper-info col-12 px-0">
                      <div className="paper-info col-md-5 px-0">
                        <img src={Papers} alt="icon" className="paper-icon" />
                        <p className="subject">{enrolled_paper.assess_name}</p>
                      </div>
                      <div className="paper-text col-md-7 px-0">
                        <div className="col-md-4 px-0">
                          <p className="subject">{enrolled_paper.subject_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">{enrolled_paper.language_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">Grade {enrolled_paper.grade_name || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state-box">
                  <HiInbox className="empty-state-icon" />
                  <p className="empty-state-text">You haven't enrolled in any exams yet</p>
                  <p className="empty-state-subtext">Browse available exams to get started</p>
                </div>
              )}
            </div>
          )}

          {tabIndex === 2 && (
            <div className="paper-list">
              {completedPapers && completedPapers.length > 0 ? (
                completedPapers.map((completed_paper, index) => (
                  <div className="paper-row" key={index}>
                    <div className="paper-info col-12 px-0">
                      <div className="paper-info col-md-5 px-0">
                        <img src={Papers} alt="icon" className="paper-icon" />
                        <p className="subject">{completed_paper.assess_name}</p>
                      </div>
                      <div className="paper-text col-md-7 px-0">
                        <div className="col-md-4 px-0">
                          <p className="subject">{completed_paper.subject_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">{completed_paper.language_name || "N/A"}</p>
                        </div>
                        <div className="col-md-4 px-0">
                          <p className="language">Grade {completed_paper.grade_name || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state-box">
                  <HiInbox className="empty-state-icon" />
                  <p className="empty-state-text">No completed exams to display</p>
                  <p className="empty-state-subtext">Your completed assessments will appear here</p>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaperDetails;
